import React, { useState } from 'react';
import { supabase } from '../../../services/supabaseClient';

const AddClientModal = ({ onClose, onClientAdded }) => {
    const [formData, setFormData] = useState({
        first_name: '',
        last_name: '',
        primary_email: '',
        primary_phone: '',
        nationality: '',
        passport_no: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            if (!formData.first_name || !formData.primary_email) {
                throw new Error('First Name and Email are required');
            }

            const { data, error: insertError } = await supabase
                .from('clients')
                .insert([formData])
                .select()
                .single();

            if (insertError) throw insertError;

            onClientAdded(data);
            onClose();
        } catch (err) {
            console.error('Error adding client:', err);
            setError(err.message || 'Failed to add client');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
            <div className="bg-gray-800 border border-gray-700 rounded-lg shadow-2xl w-full max-w-md overflow-hidden animate-fadeIn">
                <div className="bg-gray-900/50 p-4 border-b border-gray-700 flex justify-between items-center">
                    <h3 className="text-lg font-bold text-white uppercase tracking-wider">Add New Client</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-white">✕</button>
                </div>

                <form onSubmit={handleSubmit} className="p-6 space-y-4">
                    {error && (
                        <div className="p-3 bg-red-900/20 border border-red-800 rounded text-red-400 text-sm">
                            {error}
                        </div>
                    )}

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">First Name *</label>
                            <input
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                                placeholder="John"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Last Name</label>
                            <input
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                                placeholder="Doe"
                            />
                        </div>
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Email *</label>
                        <input
                            name="primary_email"
                            type="email"
                            value={formData.primary_email}
                            onChange={handleChange}
                            className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                            placeholder="john@example.com"
                        />
                    </div>

                    <div>
                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Phone</label>
                        <input
                            name="primary_phone"
                            value={formData.primary_phone}
                            onChange={handleChange}
                            className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                            placeholder="+1 234 567 890"
                        />
                    </div>

                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nationality</label>
                            <input
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                                placeholder="Country"
                            />
                        </div>
                        <div>
                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Passport No</label>
                            <input
                                name="passport_no"
                                value={formData.passport_no}
                                onChange={handleChange}
                                className="w-full bg-gray-900 border border-gray-600 rounded px-3 py-2 text-white focus:ring-1 focus:ring-blue-500 font-mono"
                                placeholder="A1234567"
                            />
                        </div>
                    </div>

                    <div className="pt-4 flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 rounded text-xs font-bold bg-gray-700 text-white hover:bg-gray-600 uppercase border border-gray-600"
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 rounded text-xs font-bold bg-blue-600 text-white hover:bg-blue-700 uppercase border border-blue-500 flex items-center gap-2"
                            disabled={loading}
                        >
                            {loading && <div className="animate-spin h-3 w-3 border-b-2 border-white rounded-full" />}
                            {loading ? 'Creating...' : 'Create Client'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddClientModal;
